'use client'

import type React from 'react'
import { use } from 'react'
import { useModals } from '@/lib/hooks'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import { SelectOtherPaymentType } from '@/components/forms/select-other-payment-type'
import { RefContext, type Refs } from '@/components/providers/ref-provider'

interface SelectOtherPaymentTypeModalProps
  extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const SelectOtherPaymentTypeModal = ({
  open,
}: SelectOtherPaymentTypeModalProps) => {
  const { closeModal, closeAll } = useModals()
  const { amountInputRef } = use(RefContext) as Refs

  return (
    <Dialog
      open={open}
      onOpenChange={(open) => {
        if (!open) {
          amountInputRef?.current?.focus()
        }
      }}
    >
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('SELECT_OTHER_PAYMENT_TYPE')}
        size="lg"
        className="lg:min-h-[410px]"
      >
        <DialogHeader>
          <DialogTitle>Payment Method</DialogTitle>
          <DialogDescription>
            Select the preferred payment method
          </DialogDescription>
        </DialogHeader>

        {open && <SelectOtherPaymentType onClose={() => closeAll()} />}
      </DialogContent>
    </Dialog>
  )
}
